export const ELASTIC_SEARCH_DIRECTORY =
  process.env.NODE_ENV === "production" ? "hallow-app-v3" : "hallow-app-v3-dev";
